import React from 'react';
import { Avatar, Box, Button, Divider, Typography } from '@mui/material';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import { ProfileProps } from './CommonProps';

const ProfileCard = (props: Readonly<ProfileProps>) => {
  return (
    <Box sx={{ width: 300, display: 'flex', flexDirection: 'column' }}>
      {/* Identity Block */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 3,
        }}
      >
        <Box sx={{ position: 'relative', mb: 2 }}>
          <Avatar
            src={props.profileimageurl}
            sx={{
              width: 72,
              height: 72,
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            }}
          />
        </Box>

        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
            mb: 0.5,
          }}
        >
          {props.username}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
          {props.email}
        </Typography>

        <Button
          variant="outlined"
          fullWidth
          href={props.accounturl}
          target="_blank"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            color: 'text.primary',
            borderColor: 'divider',
            '&:hover': {
              borderColor: 'text.primary',
              bgcolor: 'action.hover',
            },
          }}
        >
          Manage Account
        </Button>
      </Box>

      <Divider />

      {/* Footer Actions */}
      <Box sx={{ p: 1, bgcolor: 'background.default' }}>
        <Button
          onClick={props.logOut}
          startIcon={<PersonAddAltOutlinedIcon />}
          fullWidth
          color="inherit"
          sx={{
            justifyContent: 'flex-start',
            px: 2,
            py: 1,
            borderRadius: 2,
            color: 'text.primary',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
              bgcolor: 'action.hover',
            },
          }}
        >
          Sign in with a different account
        </Button>
      </Box>
    </Box>
  );
};

export default ProfileCard;
